///<reference path="../../graphql/graphql-types.d.ts" />
import type { ApolloError, ServerError } from '@apollo/client'

import React from 'react'
import { errorCodeToMessage } from '@@partner:helpers/errors'

import CommonErrorDisplay from './CommonErrorDisplay'

import './GraphQLCommonErrorDisplay.scss'

export interface GraphQLCommonErrorDisplayProps {
  title?: string
  error?: ApolloError
}

const GraphQLCommonErrorDisplay: React.FC<GraphQLCommonErrorDisplayProps> = ({
  error,
  title = 'Ошибка выполнения запроса',
  children
}) => {
  if (error) {
    const networkErrors =
      (error.networkError as ServerError)?.result?.errors ?? []

    return (
      <CommonErrorDisplay title={title} error={error}>
        {error.graphQLErrors.map((gqlError, index) => (
          <p key={index}>
            {errorCodeToMessage(gqlError.code) ?? gqlError.message}
          </p>
        ))}

        {networkErrors.map((gqlError: Error, index: number) => (
          <p key={index}>{gqlError.message}</p>
        ))}

        {children}
      </CommonErrorDisplay>
    )
  }

  return null
}

export default GraphQLCommonErrorDisplay
